var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"id":"role-sidepage-role-policies-list","list":_vm.list,"columns":_vm.tableColumns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"default-search-key":"policy_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }